import { irisTrackerService } from 'packages/common/services';

const origin = 'PERSONNEL_DEPARTMENT';
const catalogName = 'personnelDepartment';

export const clickSaveServiceTakerTracker = () => {
  const catalog = irisTrackerService.getCatalog(catalogName);
  return irisTrackerService.buildTracker({
    catalog,
    view: catalog.views.serviceTakerRollover,
    origin,
  }).setAction(catalog.actions.clickSaveServiceTaker)
    .send();
};
